import styled from 'styled-components';

export const PreviewDialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 700px;
  border-radius: 12px;
  background: #ffffff;
`;

export const PreviewDialogHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #c9c6cc80;
`;

export const PreviewDialogTitle = styled.span`
  font-family: IBM Plex Sans;
  font-size: 19px;
  font-weight: 500;
  color: #1e252a;
`;

export const PreviewDialogHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PreviewEditButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #7200E0;
  border-radius: 25px;
  cursor: pointer;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #7200E0;
  &:hover { background: #f2f1f380; }
`;

export const PreviewDialogContent = styled.div`
  padding: 20px;
`;

export const CriteriaHeaderRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
  padding-left: 8px;
`;

export const MarksHeaderLabel = styled.span`
  font-family: IBM Plex Sans;
  font-size: 14px;
  font-weight: 600;
  color: #4B464F;
  width: 50px;
`;

export const CriteriaHeaderLabel = styled.span`
  font-family: IBM Plex Sans;
  font-size: 14px;
  font-weight: 600;
  color: #4B464F;
  flex: 1;
`;

export const CriteriaListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CriteriaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const MarksBox = styled.div`
  width: 50px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #C9C6CC;
  border-radius: 6px;
  font-family: IBM Plex Sans;
  font-size: 16px;
  font-weight: 500;
  color: #1e252a;
  flex-shrink: 0;
`;

export const CriteriaBox = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 44px;
  display: flex;
  align-items: flex-start;
  padding: 8px 16px;
  border: 1px solid #C9C6CC;
  border-radius: 6px;
  font-family: IBM Plex Sans;
  font-size: 16px;
  line-height: 1.5;
  color: #1e252a;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const PreviewContentWrapper = styled.div`
  padding: 16px;
`;

export const SmallMarksBox = styled.div`
  width: 50px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #C9C6CC;
  border-radius: 6px;
  font-family: IBM Plex Sans;
  font-size: 16px;
  font-weight: 500;
  color: #1e252a;
  flex-shrink: 0;
`;

export const SmallCriteriaBox = styled.div`
  flex: 1;
  min-height: 40px;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid #C9C6CC;
  border-radius: 6px;
  font-family: IBM Plex Sans;
  font-size: 14px;
  color: #1e252a;
`;

export const ImportButtonContainer = styled.div`
  margin-top: auto;
  padding: 16px;
  border-top: 1px solid #C9C6CC80;
`;

export const ImportButtonLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  padding: 10px 16px;
  border: 1px solid #7200E0;
  border-radius: 20px;
  cursor: pointer;
`;

export const ImportButtonIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const ImportButtonText = styled.span`
  font-family: IBM Plex Sans;
  font-size: 14px;
  font-weight: 500;
  color: #7200E0;
`;

export const TemplateCard = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 8px 16px;
  background-color: ${props => props.isSelected ? '#F1E6FC' : '#ffffff'};
`;

export const TemplateTitleBorder = styled.p`
  padding: 10px;
  font-family: IBM Plex Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  background: #f2f1f3;
  color: #4b464f;
  border-top: 1px solid #C9C6CC80;
`;
